import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const PHONE_LINK = "tel:+33549057490";

export const CtaBlock = ({ relatedSlugs }) => {
  const links = relatedSlugs || [];
  return (
    <section className="py-12 bg-gradient-to-r from-red-600 to-red-700 text-white" data-testid="cta-block">
      <div className="container-custom max-w-4xl text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Besoin d&apos;aide ou d&apos;un diagnostic ?
        </h2>
        <p className="text-lg text-red-100 mb-8 max-w-2xl mx-auto">
          Mediastore Niort - 104 Rue de la Gare, 79000 Niort. Diagnostic gratuit sur place.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <a href={PHONE_LINK}>
            <Button size="lg" className="bg-white text-red-600 hover:bg-red-50 h-14 px-8 gap-2 text-lg font-semibold" data-testid="cta-call">
              <Phone className="h-5 w-5" />
              05 49 05 74 90
            </Button>
          </a>
          <Link to="/rendez-vous">
            <Button size="lg" variant="outline" className="h-14 px-8 gap-2 border-2 border-white text-white hover:bg-white/10" data-testid="cta-rdv">
              Prendre rendez-vous
            </Button>
          </Link>
        </div>

        {links.length > 0 ? (
          <div className="border-t border-white/20 pt-6 mt-6">
            <p className="text-sm text-red-100 mb-3">Pages liées :</p>
            <div className="flex flex-wrap justify-center gap-2">
              {links.map((r) => (
                <Link key={r.ref || r.slug} to={`/${r.ref || r.slug}`} className="text-sm bg-white/15 hover:bg-white/25 px-3 py-1.5 rounded-full transition-colors">
                  {r.label} →
                </Link>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </section>
  );
};
